module.exports = __webpack_public_path__ + "static/media/eyedropper.ca301bc8.svg";